<ng-template [cdkPortalOutlet]="_referenceHeaderPortal"></ng-template>
<div class="zwi-reference-content" cdkMonitorSubtreeFocus tabindex="-1" style="z-index: 100; background: white;">
  @switch (currentView) {
    @case ('chapter') {
      <zwi-chapter-view
        [activeReference]="activeReference"
        [selected]="selected"
        [maxReference]="maxReference"
        [minReference]="minReference"
        (close)="close()"
        (selectedChange)="_verseSelected($event)">
      </zwi-chapter-view>
    }
    @case ('book') {
      <zwi-book-view
        [activeReference]="activeReference"
        [selected]="selected"
        [maxReference]="maxReference"
        [minReference]="minReference"
        (close)="close()"
        (chapterSelected)="_chapterSelected($event)"
        (selectedChange)="_goToReferenceInView($event, 'chapter')">
      </zwi-book-view>
    }
    @case ('bible') {
      <zwi-bible-view
        [activeReference]="activeReference"
        [selected]="selected"
        [maxReference]="maxReference"
        [minReference]="minReference"
        (bookSelected)="_bookSelected($event)"
        (close)="close()"
        (selectedChange)="_goToReferenceInView($event, 'book')">
      </zwi-bible-view>
    }
  }
</div>
@if (currentView !== 'bible') {
  <ng-template [cdkPortalOutlet]="_referenceFooterPortal"></ng-template>
}
<!--    [(activeReference)]="activeReference"-->
